import React, { useState } from "react";
import SkipNextIcon from "@material-ui/icons/SkipNext";
import SkipPreviousIcon from "@material-ui/icons/SkipPrevious";
import Cb1 from "./Coba/Cb1"
import Cb2 from "./Coba/Cb2"
import Cb3 from "./Coba/Cb3"
import Coba1 from "./Coba/Coba1"
import Coba2 from "./Coba/Coba2"
import Coba3 from "./Coba/Coba3"
import Coba4 from "./Coba/Coba4"

const Marimencoba = () => {
	const [page, setPage] = useState(1);
	const nextPage = () => {
		if (page < 7) setPage(page + 1);
	};
	const previousPage = () => {
		if (page > 1) setPage(page - 1);
	};

	const rumus = () => {
		if (page === 1) {
			return <Cb1 />;
		} else if (page === 2) {
			return <Cb2 />;
		} else if (page === 3) {
			return <Cb3 />;
		}  else if (page === 4) {
			return <Coba1 />;
		} else if (page === 5) {
			return <Coba2 />;
		} else if (page === 6) {
			return <Coba3 />;
		} else {
			return <Coba4 />;
		} 
	};
	return (
		<div className="container">
				<div className="row align-items-start">
				<div className="col"></div>
				<div className="col">
					<div
						className="card mt-2 border-primary"
						style={{ width: "20rem", borderRadius: "20px" }}
					>
						<div
							style={{ backgroundColor: "#40bf80", borderRadius: "20px" }}
							className="card-header"
						>
							<h6 className="text-white text-center">Petunjuk Pengerjaan</h6>
						</div>
						<div className="card-body">
							<ol>
                                <li>Perhatikan Gambar !</li>
								<li>Kalian harus mengisi kendala pertidaksamaan</li>
								<li>Apabila benar maka border form akan berwarna hijau</li>
								<li>Apabila salah maka border form akan berwarna merah</li>
								<li>Gambar dapat kalian zoom</li>
							</ol>
						</div>
					</div>
				</div>
				<div className="col"></div>
			</div>
			<div className="mt-2 mb-2">{rumus()}</div>
			<div className="row d-flex justify-content-center align-items-center">
				<div className="col-lg-10 mb-1  ">
					<div
						style={{
							marginTop: "1rem",
							display: "flex",
							justifyContent: "space-between",
						}}
					>
						<button
							style={{ backgroundColor: "#40bf80" }}
							className="btn"
							onClick={() => previousPage()}
							disabled={page === 1 ? true : false}
						>
							<SkipPreviousIcon style={{ color: "white" }} />
						</button>
						<button
							style={{ backgroundColor: "#40bf80" }}
							className="btn"
							onClick={() => nextPage()}
							disabled={page === 7 ? true : false}
						>
							<SkipNextIcon style={{ color: "white" }} />
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Marimencoba;
